import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import EditorClusterColumnChart from './ssEditorClusterColumnChart';
import RuntimeClusterColumnChart from './ssRuntimeClusterColumnChart';
import { useFormSelector } from '../../../custom-hooks';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import { FCM_CONTAINER_STYLES } from '../../constants/runtime.constants';
import { getEvaluatedExpression } from '../../selectors/form-manager.selectors';
import { getEvaluatedClusterColumnChartData } from '../../selectors/runtime.selectors';
import { equalityFn } from '../../utils/form-manager.utils';

const useStyles = makeStyles(FCM_CONTAINER_STYLES);

const SSClusterColumnChart = ({
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  id,
  index,
  isEditor,
  ...otherProps
}) => {
  const classes = useStyles({ isControlAddedFCM });

  const title = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    prop: FORM_MODEL_ATTRIBUTES.TITLE,
  });
  const header = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    prop: FORM_MODEL_ATTRIBUTES.HEADER,
    defaultValue: true,
  });
  const evaluatedData = useFormSelector(
    getEvaluatedClusterColumnChartData,
    {
      id,
      index,
    },
    equalityFn
  );

  const props = { id, header, evaluatedData, ...otherProps, title };

  if (isEditor) {
    return <EditorClusterColumnChart {...props} />;
  }

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={id}>
        <div
          className={classNames(classes.control, isControlHiddenFCM ? classes.hiddenControl : '')}
          data-hidden-fcm={isControlHiddenFCM}
        >
          <RuntimeClusterColumnChart {...props} />
        </div>
        {isControlChangedFCM && (
          <div className={classes.changesIcon}>
            <ControlChangesIcon id={id} />
          </div>
        )}
      </div>
    );
  }

  if (isControlHiddenFCM) {
    return (
      <div className={classes.hiddenControl} data-hidden-fcm="true">
        <RuntimeClusterColumnChart {...props} />
      </div>
    );
  }

  return <RuntimeClusterColumnChart {...props} />;
};

export default SSClusterColumnChart;
